export const MYSQL_DATE_FORMAT = 'YYYY-MM-DD'
export const WEEKDAYS = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']
export const DAY_BEGIN_TIME = 'T00:00:00.000Z'
export const MYSQL_ZERO_DATE = '0000-00-00'
export const TIME_START_OF_DAY_H_M = '00:00'
export const DAY_MONTH_DATE = 'iii, MMM. dd'
